import { render, staticRenderFns } from "./ObjectsList.vue?vue&type=template&id=087344e7&scoped=true&"
import script from "./ObjectsList.vue?vue&type=script&lang=js&"
export * from "./ObjectsList.vue?vue&type=script&lang=js&"
import style0 from "./ObjectsList.vue?vue&type=style&index=0&id=087344e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087344e7",
  null
  
)

export default component.exports